import React, { useState, useEffect, useRef, useCallback } from 'react';

import './Header.css';

function Header(props) {

	const MINIMUM_SCROLL = 100;
	const TIMEOUT_DELAY = 100;

	const [shouldHideHeader, setShouldHideHeader] = useState(false);

	const hideHeader = props.hideHeader;
	const setSidenavOpen = props.setSidenavOpen;

	useEffect(() => {
		if (hideHeader) {
			setShouldHideHeader(true);
		} else {
			setShouldHideHeader(false);
		}
	}, [hideHeader]);

	const previousScrollTopRef = useRef(0);

	const handleDocumentScroll = useCallback(() => {
		const currentScrollTop = window.scrollY;
		const deltaScrollTop = currentScrollTop - previousScrollTopRef.current;
		previousScrollTopRef.current = currentScrollTop;
		const isMinimumScrolled = currentScrollTop > MINIMUM_SCROLL;

		setTimeout(() => {
			if (hideHeader) {
				return;
			}

			if (isMinimumScrolled) {
				setShouldHideHeader(deltaScrollTop > 0);
			} else {
				setShouldHideHeader(false);
			}
		}, TIMEOUT_DELAY);
	}, [hideHeader]);

	useEffect(() => {
		window.addEventListener('scroll', handleDocumentScroll);

		return () => {
			window.removeEventListener('scroll', handleDocumentScroll);
		}
	}, [handleDocumentScroll]);

	const hiddenClass = shouldHideHeader ? 'hidden' : '';

	return (
		<div className='header-container'>
			<header className={`header ${hiddenClass}`}>
				<div>
					<div className='menu' onClick={() => setSidenavOpen(true)}>
						<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 50 50">
							<path d="M 3 9 A 1.0001 1.0001 0 1 0 3 11 L 47 11 A 1.0001 1.0001 0 1 0 47 9 L 3 9 z M 3 24 A 1.0001 1.0001 0 1 0 3 26 L 47 26 A 1.0001 1.0001 0 1 0 47 24 L 3 24 z M 3 39 A 1.0001 1.0001 0 1 0 3 41 L 47 41 A 1.0001 1.0001 0 1 0 47 39 L 3 39 z">
							</path>
						</svg>
					</div>
					<div className='title'>
						<h3>Jill Bryars</h3>
						<h4>Artist. Drawing. Making the figure.</h4>
					</div>
				</div>
			</header>
		</div>
	);

}

export default (Header);